import { render, staticRenderFns } from "./CreateBreadFieldCard.vue?vue&type=template&id=64974b99&"
import script from "./CreateBreadFieldCard.vue?vue&type=script&lang=js&"
export * from "./CreateBreadFieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports